import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = ["id", "checked"]
const _hoisted_3 = {
  class: "checkmark",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_4 = ["stroke"]
const _hoisted_5 = {
  key: 0,
  class: "text-container"
}
const _hoisted_6 = { class: "" }

import { computed, ref } from 'vue'

interface Props {
  title?: string
  description?: string
  color: string
  tintColor: string
  checkedColor?: string
  valid?: boolean | undefined
  error?: string | undefined
  checked?: boolean
  borderColor?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'GraphCardCheckbox',
  props: {
    title: { default: '' },
    description: { default: '' },
    color: { default: 'blue' },
    tintColor: { default: 'white' },
    checkedColor: { default: 'green' },
    valid: { type: Boolean, default: undefined },
    error: { default: undefined },
    checked: { type: Boolean, default: false },
    borderColor: { default: 'grey' }
  },
  emits: ["valueChanged"],
  setup(__props: any) {

_useCssVars(_ctx => ({
  "9b8f7ef6": (checkedColor.value),
  "5904a6fa": (color.value),
  "03ea9e24": (_ctx.borderColor),
  "413b653f": (tintColor.value)
}))



const id = ref<string>(`checkbox-${Math.random()}`)

const props = __props

const color = computed(() => {
  return props.color
})

const tintColor = computed(() => {
  return props.tintColor
})

const backgroundColor = computed<string>(() => {
  return props.checked ? 'checked' : 'unchecked'
})

const glowColor = computed<string>(() => {
  if (props.error) return 'error'
  return 'default'
})

const checkedColor = computed(() => {
  return props.checked ? props.checkedColor : props.color
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      class: _normalizeClass(["checkbox-container", [glowColor.value]])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["checkbox", [backgroundColor.value]])
      }, [
        _createElementVNode("input", {
          id: id.value,
          type: "checkbox",
          checked: _ctx.checked,
          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('valueChanged', $event)))
        }, null, 40, _hoisted_2),
        (_openBlock(), _createElementBlock("svg", _hoisted_3, [
          _createElementVNode("path", {
            d: "M20 6L9 17L4 12",
            stroke: tintColor.value,
            "stroke-width": "5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, _hoisted_4)
        ]))
      ], 2)
    ], 2),
    (_ctx.title || _ctx.description)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.title), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.description), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})